import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVisaSquare = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 38,
	height: 38,
	viewBox: "0 0 38 38",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 37,
			height: 37,
			rx: 7.5,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 37,
			height: 37,
			rx: 7.5,
			stroke: "#ECECEF"
		}),
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_11042_233409)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M22.6371 15.1094C20.9352 15.1094 19.4072 15.9969 19.4072 17.6256C19.4072 19.5013 22.1064 19.6294 22.1064 20.5627C22.1064 20.9561 21.6489 21.313 20.8803 21.313C19.7823 21.313 18.9588 20.8189 18.9588 20.8189L18.6111 22.4658C18.6111 22.4658 19.5536 22.8867 20.8162 22.8867C22.6828 22.8867 24.1468 21.9626 24.1468 20.2973C24.1468 18.321 21.4384 18.1929 21.4384 17.3236C21.4384 17.0125 21.8136 16.674 22.5822 16.674C23.4514 16.674 24.1651 17.0308 24.1651 17.0308L24.5128 15.4388C24.5036 15.4388 23.7259 15.1094 22.6371 15.1094ZM7.04575 15.2283L7 15.4662C7 15.4662 7.71369 15.5943 8.36332 15.8597C9.19596 16.1616 9.25086 16.3355 9.39726 16.8753L10.9253 22.7586H12.9748L16.1132 15.2283H14.0728L12.0507 20.3522L11.2272 16.0061C11.154 15.512 10.7697 15.2283 10.2939 15.2283H7.04575ZM16.9367 15.2283L15.3355 22.7586H17.2844L18.8765 15.2283H16.9367ZM27.7884 15.2283C27.3218 15.2283 27.0747 15.4754 26.8917 15.9146L24.037 22.7586H26.0774L26.4708 21.6149H28.9596L29.1975 22.7586H31L29.4354 15.2283H27.7884ZM28.0538 17.2687L28.6576 20.096H27.0381L28.0538 17.2687Z",
				fill: "#1434CB"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_11042_233409",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 7.77735,
				fill: "white",
				transform: "translate(7 15.1094)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgVisaSquare);
export { ForwardRef as ReactComponent };
